import React from 'react';

export const Drawer = ({ drawerId, activeTab, setActiveTab, children }) => {
    return (
        <>
            {/* <input type="checkbox" id={drawerId} className="modal-toggle" /> */}
            <div
                className={
                    activeTab === drawerId
                        ? `modal-open modal modal-bottom lg:relative`
                        : `modal modal-bottom md:relative lg:hidden`
                }
                id={drawerId}
            >
                <div
                    className='modal-box relative p-0 min-h-80 mb-20 lg:mb-0  max-h-[calc(100vh-300px)] md:max-h-[calc(100vh-300px)]'>
                    <div
                        className='lg:hidden bg-neutral border-b border-t border-solid border-[#4F4F4F] h-12 flex justify-center items-center  sticky top-0 z-[999]'>
                        <label
                            htmlFor={drawerId}
                            className='absolute right-4 top-3'
                            onClick={() => setActiveTab('')}
                        >
                            ✕
                        </label>
                        <h3 className='text-base font-semibold text-center text-[#f6f6f6] capitalize'>
                            {drawerId}
                        </h3>
                    </div>

                    <div className='m-4'>{children}</div>
                </div>
            </div>
        </>
    );
};